import React from 'react';

const EmailReplyNotice = ({ smtpEmail }) => {
  return (
    <div style={{ 
      background: 'var(--color-background-secondary)',
      border: '1px solid var(--color-border-primary)',
      borderRadius: '8px',
      padding: '16px',
      marginBottom: '24px',
      display: 'flex',
      alignItems: 'flex-start',
      gap: '12px'
    }}>
      <div style={{ fontSize: '24px' }}>📬</div>
      <div>
        <h4 style={{ margin: '0 0 8px 0', fontSize: '16px', fontWeight: 'bold' }}>Want to see replies?</h4>
        <p style={{ margin: '0 0 4px 0', fontSize: '14px', color: 'var(--color-text-secondary)' }}>
          If a recipient replies to this campaign email, their reply will land directly in your inbox.
        </p>
        <p style={{ margin: '0 0 4px 0', fontSize: '14px', color: 'var(--color-text-secondary)' }}>
          <strong>Login to your email account</strong> (Gmail / Outlook / Yahoo / etc.) to view any replies.
        </p>
        <p style={{ margin: '0', fontSize: '14px', color: 'var(--color-text-secondary)' }}>
          Replies are sent to: <strong style={{ fontFamily: 'monospace', background: 'var(--color-background-primary)', padding: '2px 6px', borderRadius: '4px' }}>{smtpEmail || 'your-email@domain.com'}</strong>
        </p>
      </div>
    </div>
  );
};

export default EmailReplyNotice;
